<template>
  <div>
    <top :title="title"></top>

    <!-- 纯原生搜索区域：关键词输入 + 原生状态筛选下拉 -->
    <div class="search-box" v-if="showSearch">
      <!-- 订单号/款号搜索框 -->
      <div class="search-input">
        <input
          type="search"
          v-model="keywords"
          placeholder="搜索订单号/款号"
          @keyup.enter="handleSearch"
          @search="handleSearch"
          inputmode="search"
        />
        <div class="search-btn" @click="handleSearch">
          <i class="el-icon-search"></i>
        </div>
      </div>
    </div>

    <div class="order-con" :class="{ 'with-search': showSearch }">
      <div class="order-item" v-for="(item, index) in orderList" :key="index">
        <div class="title flex ali-cen jusc-be">
          <div>No:{{ item.orderNumber }}</div>
        </div>
        <div class="oder-info">
          <image-preview
            class="good-img"
            :src="item.img"
            :width="62"
            :height="62"
          />
          <div class="infos">
            <div class="flex jusc-be">
              <div class="style">款号：{{ item.styleCode }}</div>
              <div class="num">x{{ item.shipmentTotalNumber }}</div>
            </div>
            <div class="time">加工厂：{{ item.deptName }}</div>
            <div class="time">剩余：{{ item.remainingShipmentNumber }}</div>
          </div>
        </div>
        <!-- <div class="btn-box">
                    <div class="use-btn"  @click="goDetails(item)">制衣出货</div>
                </div> -->
      </div>

      <!-- 无搜索结果提示 -->
      <div class="empty-tip" v-if="orderList.length === 0">
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import {
  settlePageClothingShipment,
  deptSettlePageClothingShipment,
} from "@/http/index";

export default {
  components: {
    top,
  },
  data() {
    return {
      orderList: [],
      title: "",
      type: "",
      keywords: "",
      showSearch: true,
      // 状态筛选相关
      statusValue: "", // 选中的状态值
      statusDropdownShow: false, // 下拉菜单显示状态
      statusList: [
        { type: "", name: "全部状态" },
        { type: 1, name: "已打单" },
        { type: 2, name: "已打纸" },
        { type: 3, name: "已转印" },
        { type: 4, name: "已激光" },
        { type: 5, name: "制衣生产中" },
        { type: 6, name: "制衣部分出货" },
        { type: 7, name: "制衣全部出货" },
      ],
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.getList();
    // 监听点击空白处关闭下拉
    document.addEventListener("click", this.handleDocumentClick);
  },
  destroyed() {
    // 移除事件监听，避免内存泄漏
    document.removeEventListener("click", this.handleDocumentClick);
  },
  methods: {
    getStatus(e) {
      const status = this.statusList.find((item) => item.type == e);
      return status ? status.name : "";
    },

    // 切换状态下拉菜单显示/隐藏
    toggleStatusDropdown(e) {
      e.stopPropagation(); // 阻止事件冒泡
      this.statusDropdownShow = !this.statusDropdownShow;
    },

    // 选择状态选项
    selectStatus(item) {
      this.statusValue = item.type;
      this.statusDropdownShow = false; // 选择后关闭下拉
      this.handleSearch(); // 触发搜索
    },

    // 点击空白处关闭下拉菜单
    handleDocumentClick() {
      this.statusDropdownShow = false;
    },

    getList() {
      // 统一请求参数
      const requestParams = {
        pageNum: 1,
        pageSize: 1000,
        keywords: this.keywords,
      };
      this.title = "结算清单";
      if (this.type == "settleDeptShipment") {
        deptSettlePageClothingShipment(requestParams).then((res) => {
          this.orderList = res.rows;
        });
      } else {
        settlePageClothingShipment(requestParams).then((res) => {
          this.orderList = res.rows;
        });
      }
    },

    handleSearch() {
      // 清空列表后重新请求，提升体验
      this.orderList = [];
      this.getList();
    },
    goDetails(data) {
      this.$router.push({
        path: "/shipmentAdd",
        query: { id: data.id, orderId: data.orderId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 纯原生搜索区域样式 */
.search-box {
  padding: 12px 24px 0;
  background-color: #f7f8fa;
  display: flex;
  flex-direction: column;
  gap: 10px; /* 输入框和筛选框间距 */

  .search-input {
    position: relative;
    display: flex;
    align-items: center;

    input {
      flex: 1;
      height: 36px;
      padding: 0 15px 0 40px;
      border: 1px solid #e4e7ed;
      border-radius: 18px;
      background-color: #fff;
      font-size: 14px;
      color: #303133;

      &:focus {
        outline: none;
        border-color: #e44338;
      }

      &::placeholder {
        color: #c0c4cc;
      }
    }

    .search-btn {
      position: absolute;
      left: 12px;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #909399;
    }
  }

  /* 原生状态筛选样式 */
  .status-select {
    width: 100%;
    position: relative;

    .select-wrap {
      width: 100%;
      height: 36px;
      border: 1px solid #e4e7ed;
      border-radius: 18px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      font-size: 14px;
      color: #303133;
      cursor: pointer;

      .select-text {
        flex: 1;
        text-align: left;
      }

      .arrow-icon {
        width: 12px;
        height: 12px;
        border: solid #909399;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        transition: transform 0.2s ease;

        &.active {
          transform: rotate(-135deg);
          margin-top: 5px;
        }
      }
    }

    .select-dropdown {
      position: absolute;
      top: 42px;
      left: 0;
      right: 0;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      z-index: 999;
      max-height: 200px;
      overflow-y: auto;

      .dropdown-item {
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        font-size: 14px;
        color: #303133;
        cursor: pointer;

        &:hover {
          background-color: #f5f7fa;
        }

        &.active {
          color: #e44338;
          font-weight: 500;
          background-color: #fef0f0;
        }
      }
    }
  }
}

.order-con {
  background-color: #f7f8fa;
  padding: 24px;
  height: 100vh;

  &.with-search {
    padding-top: 12px;
  }

  .order-item {
    background: #ffffff;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 12px;

    .title {
      font-size: 14px;
      color: #303133;
      margin-bottom: 16px;
      font-weight: bold;
    }

    .status {
      font-weight: 600;
      font-size: 14px;
      color: #e44338;
    }

    .oder-info {
      display: flex;
      align-items: center;

      .good-img {
        width: 90px;
        height: 62px;
        border-radius: 4px;
        margin-right: 10px;
      }

      .infos {
        flex: 1;
      }

      .style {
        font-weight: 500;
        font-size: 14px;
        color: #303133;
      }

      .num {
        text-align: right;
        font-weight: 500;
        font-size: 14px;
        color: #909399;
      }

      .time {
        font-weight: 400;
        font-size: 13px;
        color: #303133;
        margin-top: 10px;
      }
    }

    .btn-box {
      display: flex;
      justify-content: flex-end;
      margin-top: 16px;

      .use-btn {
        padding: 4px 12px;
        background: #ffffff;
        border-radius: 30px;
        border: 1px solid #e24a41;
        font-weight: 600;
        font-size: 14px;
        color: #e44338;
        cursor: pointer;
      }
    }
  }

  /* 无搜索结果提示 */
  .empty-tip {
    text-align: center;
    padding: 60px 20px;

    p {
      color: #909399;
      font-size: 14px;
    }
  }
}

/* 辅助布局样式 */
.flex {
  display: flex;
}
.ali-cen {
  align-items: center;
}
.jusc-be {
  justify-content: space-between;
}
</style>
